import { defineMessages } from 'react-intl';

export default defineMessages({
	select: {
		id: 'register.education.select',
		defaultMessage: `-- select an option --`,
	},
	some_high_school: {
		id: 'register.education.some_high_school',
		defaultMessage: `Some high school`,
	},
	high_school: {
		id: 'register.education.high_school',
		defaultMessage: `Graduated high school`,
	},
	some_college: {
		id: 'register.education.some_college',
		defaultMessage: `Some college`,
	},
	college: {
		id: 'register.education.college',
		defaultMessage: `Graduated college`,
	},
	post_graduate: {
		id: 'register.education.post_graduate',
		defaultMessage: `Post graduate study`,
	},
});



// WEBPACK FOOTER //
// ./src/locales/education.js